import { render, staticRenderFns } from "./emptyRouter.vue?vue&type=template&id=9901a5a8"
import script from "./emptyRouter.vue?vue&type=script&lang=js"
export * from "./emptyRouter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports